import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom'
import NProgress from 'nprogress'
import GoogleAnalytics from 'react-ga';

import ElementMenu from './ElementMenu'
import PlayButton from './PlayButton'
import MapFilter from './MapFilter'

import Notification from '../services/Notification.js'
import Train from '../services/train.js';
import Repeller from '../services/repeller.js';
import QueryParamsUtils from '../services/QueryParamsUtils.js';
import StringUtils from '../services/StringUtils.js';
import Element from '../services/Element.js';

import MapData from '../models/MapData.js';

import '../../css/Map.css';

class Map extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      menu: {active: false},
      hover: {},
      selection: false,
      selectedElements: {}
    }

    this.elementHeight = 60;
    this.elementWidth = 150;
    this.flagWidth = 24;
    this.flagHeight = 16;
    this.headerHeight = 50;
    this.playerHeight = 60;
    this.mapHeaderHeight = 30;

  }

  componentDidMount() {    

    Element.nameById(this.mapContext(), this.mapSearchTerm(), (name) => {
      this.setState({name});
    });

    this.fetchData();

    this.eventHandler = this.updateDimensions.bind(this);

    window.addEventListener("resize", this.eventHandler);

  } 

  componentWillUnmount() {
    window.removeEventListener("resize", this.eventHandler);
  }

  componentWillReceiveProps(newProps) {

    let context = this.mapContext();
    let searchTerm = this.mapSearchTerm();
    let type = this.mapType();
    let typeTerm = this.mapTypeTerm();

    if (context !== this.mapContext(newProps) || searchTerm !== this.mapSearchTerm(newProps) 
      || type !== this.mapType(newProps) || typeTerm !== this.mapTypeTerm(newProps)) {

      this.setState({
        menu: {
          active: false
        },
        selectedElements: {}
      });

    }

    this.props = newProps;

    this.fetchData();
  }

  buildMapSearchParams() {
    let queryParams = new URLSearchParams(this.props.location.search);
    let searchParams = {};

    for(let entry of queryParams.entries()) {
      searchParams[entry[0]] = entry[1]; 
    }

    searchParams['tags'] = (queryParams.has('tags') && queryParams.getAll('tags')) || queryParams.getAll('tag');
    searchParams['countries'] = (queryParams.has('countries') && queryParams.getAll('countries')) || queryParams.getAll('country');
    searchParams['genders'] = (queryParams.has('genders') && queryParams.getAll('genders')) || queryParams.getAll('gender');
    searchParams['tourCountries'] = (queryParams.has('tourCountries') && queryParams.getAll('tourCountries')) || queryParams.getAll('tourCountry');
    searchParams['timePeriods'] = (queryParams.has('timePeriods') && queryParams.getAll('timePeriods')) || queryParams.getAll('timePeriod');

    return searchParams;
  }

  buildMapParams() {

    let searchParams = this.buildMapSearchParams();

    let mapParams = {
      context: this.mapContext(), 
      searchTerm: this.mapSearchTerm(), 
      mapType: this.mapType(), 
      mapTypeTerm: this.mapTypeTerm(),
      genders: [],
      countries: [],
      tags: []
    };

    mapParams = Object.assign(mapParams, searchParams);

    return mapParams;
  }


  filter(filters, cb) {
    this.hideMenu();
    this.setState({showEdges: filters.showEdges, selection: filters.selection});

    let searchParams = this.buildMapSearchParams();

    let params = Object.assign(searchParams, filters);

    delete params.showEdges;
    delete params.selection;

    params = QueryParamsUtils.toQueryParams(params);

    this.props.history.push(params);
  }

  fetchData() {

    GoogleAnalytics.event({
      category: 'SimilarityMap',
      action: 'loaded',
      label: this.props.location.pathname
    });

    let mapParams = this.buildMapParams();

    this.setState({
      selectedTags: mapParams.tags,
      selectedCountries: mapParams.countries,
      selectedGenders: mapParams.genders
    });

    if (JSON.stringify(this.previousMapParams || {}) === JSON.stringify(mapParams)) {
      return;
    }

    NProgress.start();

    Notification.show('Loading map', 'info');

    Train.fetchMapData(mapParams)
    .then((data) => {

      Element.nameById(this.mapContext(), this.mapSearchTerm(), (name) => {
        this.setState({name, tags: data.top_tags, countries: data.top_countries});
      });

      this.previousMapParams = mapParams;

      this.drawingData = { mapSizeFactor: 1,
        scale: 1,
        maxElementsNumber: 100,
        deltaX: 0,
        deltaY: 0 
      }

      let mapData = new MapData(data);

      this.calculateDrawingFactors(mapData);

      if (mapData.getElementsNumber() > 1) {
       Repeller(mapData, this.getWidth(), this.getHeight(), this.drawingData.mapSizeFactor);
      } 

      if (mapData.getElementsNumber() > 0) {
        NProgress.done();
        this.setState({mapData});
      } else if (mapData.getElementsNumber() === 0 && this.previousMapParams) {
        NProgress.done();
        Notification.show('No data found for these filters. Showing previous results.', 'warning');
        this.props.history.goBack();
      } else if (mapData.getElementsNumber() === 0) {
        NProgress.done();
        Notification.show('No data found for map.', 'warning');
      }

    })
    .catch((error) => {

      if (this.previousMapParams) {
        NProgress.done();
        Notification.show('No data found for these filters. Showing previous results.', 'warning');
        this.props.history.goBack();
      } else {
        NProgress.done();
        Notification.show('No data found for map.', 'warning');
      }

    });
  }

  mapName() {
    return this.state.name;
  }

  mapElement() {
    let element = {};
    element[this.mapContext()] = this.mapSearchTerm();
    return element;
  }

  mapSearchTerm(props) {
    props = props || this.props;
    return decodeURIComponent(props.match.params.searchTerm);
  }

  mapContext(props) {
    props = props || this.props;
    return props.match.params.context;
  }

  mapType(props) {
    props = props || this.props;
    return props.match.params.mapType;
  }

  mapTypeTerm(props) {
    props = props || this.props;
    return props.match.params.mapTypeTerm || '';
  }

  updateDimensions() {
    let mapData = this.state.mapData;

    if (!mapData)
      return;

    this.calculateDrawingFactors(mapData);
    Repeller(mapData, this.getWidth(), this.getHeight(), this.drawingData.mapSizeFactor);
    this.setState({});
  }

  getWidth() {
    let width = Math.max(document.getElementById('container').offsetWidth*0.96, 1500);
    return width;
  }

  getHeight() {
    let height = Math.max((document.getElementById('App').offsetHeight - this.headerHeight - this.mapHeaderHeight - this.playerHeight)*0.98, 800);
    return height;
  }

  getCanvasX(x) {
    let drawingData = this.drawingData;
    return Math.floor(60*drawingData.scale + (this.getWidth()*drawingData.mapSizeFactor - 150*drawingData.scale)*x);
  }

  getCanvasY(y) {
    let drawingData = this.drawingData;
    return Math.floor(60*drawingData.scale + (this.getHeight()*drawingData.mapSizeFactor - 140*drawingData.scale)*y);
  }

  getVisibleElementsNumber(elementsNumber) {

    let height = this.getHeight();
    let width = this.getWidth();

    let area = width*height;

    let elementArea = this.elementHeight*this.elementWidth;

    let spacedElements = Math.floor(area / elementArea);

    spacedElements = spacedElements <= elementsNumber ? spacedElements : elementsNumber;

    return spacedElements;
  };

  calculateDrawingFactors(mapData)
  {

    if (!mapData)
      return;

    let textArea = this.getVisibleElementsNumber(mapData.getElementsNumber())*this.elementHeight*this.elementWidth;
    let area = this.getWidth()*this.getHeight();
    
    let quocient = textArea/area;

    if (quocient > 1)
    {
      this.drawingData.mapSizeFactor = quocient;
    }

    this.drawingData.scale = 1.0/this.drawingData.mapSizeFactor;

    this.drawingData.deltaX = (-this.getWidth()*this.drawingData.mapSizeFactor/ ( 2.0 ) ) + (this.getWidth()/2);
    this.drawingData.deltaY = (-this.getHeight()*this.drawingData.mapSizeFactor/ ( 2.0 ) ) + (this.getHeight()/2);



  };

  transformation() {
    let f = this.drawingData.mapSizeFactor;
    let transformation = "translate(" + this.drawingData.deltaX + "," + this.drawingData.deltaY + ")  translate(" + (f*this.getWidth()/2.0) + "," + (f*this.getHeight()/2.0) + ") scale(" + this.drawingData.scale + "," + this.drawingData.scale +  ") translate(" + (-f*this.getWidth()/2.0) + "," + (-f*this.getHeight()/2.0) + ")";
    return transformation;
  };

  elementClicked(element, index, evt) {

    if (this.state.selection === false) {
      this.showMenu(element, index, evt);
    } else {
      this.selectElement(element, evt);
    }

  }

  selectElement(element, evt) {
    let selectedElements = this.state.selectedElements;
    if (selectedElements[element])
      selectedElements[element] = false;
    else
      selectedElements[element] = true;
    this.setState(selectedElements);
  }

  showMenu(artist, index, evt) {
    evt.preventDefault();
    evt.stopPropagation();

    let factor = this.drawingData.mapSizeFactor;

    let menuData = {
      x: factor*evt.clientX, y: factor*(evt.clientY- this.headerHeight), active: true, artist: artist, artistData: this.state.mapData.getElement(index)
    }

    this.setState({menu: menuData});
  }

  hideMenu(evt) {
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
    }
    this.setState({menu: {active: false}});
  }

  isSelected(element, index) {

    let state = this.state;

    let mainElement = StringUtils.equality(element, state.menu.artist) || StringUtils.equality(element, state.hover.artist);

    if (!this.state.showEdges)
      return mainElement;

    let connectedElements = state.mapData.getConnectedNames(index);

    connectedElements = connectedElements.filter((connectedElement) => {
      return StringUtils.equality(connectedElement, state.menu.artist) || StringUtils.equality(connectedElement, state.hover.artist);
    });

    let secondaryElement = connectedElements.length > 0;
    
    return mainElement || secondaryElement;
  }

  isSelectedEdge(element, connectedTo) {

    let state = this.state;

    let mainElement = element === state.menu.artist || element === state.hover.artist;
    let secondaryElement = connectedTo === state.menu.artist || connectedTo === state.hover.artist;
    
    return mainElement || secondaryElement;
  }

  hovered(element, mapElement = false) {

    if (mapElement && this.mapContext() !== 'artist')
      return;

    let hover = {artist: element};
    this.setState({hover});
  }

  unhovered(element) {
    let hover = {artist: undefined};
    this.setState({hover});
  }

  opacity(element, index) {

    if (this.state.selection) {
      return this.state.selectedElements[element] ? 1 : 0.2;
    } else {
      if (this.state.hover.artist && !this.isSelected(element, index))
        return 0.2;
      else
        return 1;
    }

  }

  fontSize(element, index) {
    let size = this.state.mapData.getElementSize(index)
    if (!this.isSelected(element, index))
      return size;
    else
      return '1.2em';
  }

  renderEdges(elements) {

    if (!this.state.showEdges)
      return;

    let mapData = this.state.mapData;

    let edges = elements.map((element, index) => {

      let x = this.getCanvasX(mapData.getElementDisplayX(index));
      let y = this.getCanvasY(mapData.getElementDisplayY(index));

      let elementEdges = mapData.getElementEdges(index)
      .filter((elementIndex) => {
        return elementIndex < elements.length;
      })
      .map((connectedTo) => {

        let x2 = this.getCanvasX(mapData.getElementDisplayX(connectedTo));
        let y2 = this.getCanvasY(mapData.getElementDisplayY(connectedTo));
        let visibility = 'visible';

        let classes = `elementName not-selectable`;

        let stroke = this.isSelectedEdge(element, mapData.getName(connectedTo)) ? 'rgba(205,114,222, 1.0)' : 'rgba(205,114,222, 0.2)';
        
        let edge = <line 
            key={`${index}/${connectedTo}`} 
            className={classes}
            visibility={visibility}
            x1={x-this.flagWidth/2.0}
            y1={y - this.flagHeight/2.0}
            x2={x2 - this.flagWidth/2.0}
            y2={y2 - this.flagHeight/2.0}
            strokeWidth={1}
            stroke={stroke}
          >
          </line>;

        return edge;
      });

      return elementEdges;

    });

    return edges.reduce((a, b) => {
      return a.concat(b);
    });

  }

  renderNames(elements) {

    let mapData = this.state.mapData;

    return elements.map((element, index) => {

      let name = element;

      if (name.length > 20)
        name = name.slice(0,17) + '...';

      let isMainElement = this.mapContext() === 'artist' && 
                          StringUtils.equality(this.mapSearchTerm(), element);

      let x = this.getCanvasX(mapData.getElementDisplayX(index));
      let y = this.getCanvasY(mapData.getElementDisplayY(index));

      let classes = `elementName not-selectable ${isMainElement ? 'map_element' : ''}`;

      let artistName = <text 
          key={name} 
          className={classes}
          fill={mapData.getElementColor(index)}
          x={x}
          y={y}
          textDecoration={isMainElement ? 'underline' : 'none'}
          fontWeight={isMainElement ? 'bold' : 'normal'}
          cursor="pointer"
          onClick={this.elementClicked.bind(this, element, index)}
          onMouseEnter={this.hovered.bind(this, element, false)}
          onMouseLeave={this.unhovered.bind(this, element)}
          opacity={this.opacity(element, index)}
          fontSize={this.fontSize(element, index)}
        >
          {name}
        </text>;

      return (artistName);
    });
  }

  renderYears(elements) {

    let mapData = this.state.mapData;

    return elements.map((element, index) => {

      let x = this.getCanvasX(mapData.getElementDisplayX(index));
      let y = this.getCanvasY(mapData.getElementDisplayY(index));

      let startYear = mapData.getStartYear(index);

      if (mapData.hasStartYear(index))
      {    
        return (<text 
          key={element}
          x={x - this.flagWidth-5 }
          y={y - this.flagHeight - 2}
          opacity={this.opacity(element, index)}
          fill={mapData.getElementColor(index)}
          fontSize={this.fontSize(element, index)}
        >
          {startYear}
        </text>)

      }

      return '';

    });

  }

  renderGenders(elements) {

    let mapData = this.state.mapData;

    return elements.map((element, index) => {

      let x = this.getCanvasX(mapData.getElementDisplayX(index));
      let y = this.getCanvasY(mapData.getElementDisplayY(index));

      let gender = mapData.getGender(index);

      if (mapData.hasGender(index))
      {
        let factor = mapData.hasFlag(index) ? 2 : 1;
      
        return (<image 
          key={element}
          x={x - factor*this.flagWidth-5}
          y={y - this.flagHeight+2}
          width={this.flagWidth}
          height={this.flagHeight}
          xmlnsXlink="http://www.w3.org/1999/xlink" 
          xlinkHref={'img/gender_' + gender + '_icon.svg'}
          opacity={this.opacity(element, index)}

        ></image>)

      }

      return '';

    });

  }

  renderFlags(elements) {

    let mapData = this.state.mapData;

    return elements.map((element, index) => {

      let x = this.getCanvasX(mapData.getElementDisplayX(index));
      let y = this.getCanvasY(mapData.getElementDisplayY(index));

      let countryCode = mapData.getCountryCode(index);

      if (mapData.hasFlag(index))
      {
            
        return (<image 
          key={element}
          x={x - this.flagWidth - 5}
          y={y - this.flagHeight + 2}
          width={this.flagWidth}
          height={this.flagHeight}
          xmlnsXlink="http://www.w3.org/1999/xlink" 
          xlinkHref={'simple_flags/4x3/' + countryCode + '.svg'}
          opacity={this.opacity(element, index)}

        ></image>)

      }

      return '';

    });

  }

  selectAll() {

    let mapData = this.state.mapData;

    if (!mapData)
      return;

    let visibleElementsNumber = this.getVisibleElementsNumber(mapData.getElementsNumber());
    let elements = mapData.getElementsNames().slice(0, visibleElementsNumber);

    let selectedElements = {};

    elements.forEach((element) => {
      selectedElements[element] = true;
    });

    this.setState({selectedElements});
  }

  selectNone() {
    this.setState({selectedElements: {}});
  }

  render() {

    let mapData = this.state.mapData;
    let name = this.mapName();

    let showMap = mapData && name;

    let elements = [];

    if (showMap) {
      let visibleElementsNumber = this.getVisibleElementsNumber(mapData.getElementsNumber());
      elements = mapData.getElementsNames().slice(0, visibleElementsNumber);
    }

    let playableElements = elements;

    if (this.state.selection) {
      playableElements = Object.keys(this.state.selectedElements).filter((element) => {
        return this.state.selectedElements[element];
      });
    }

    playableElements = playableElements.map((name) => { return {artist: name}; } );

    return (

      <div id="map">

        <div className="header">
          <h1><Link onMouseEnter={this.hovered.bind(this, name, true)} onMouseLeave={this.unhovered.bind(this, name)} className="clickable" to={Element.url(this.mapContext(), this.mapElement())}>{name}</Link></h1>
          <PlayButton elements={playableElements} type={'artist'}/>

          <MapFilter
            selectedTags={this.state.selectedTags}
            selectedCountries={this.state.selectedCountries}
            selectedGenders={this.state.selectedGenders}
            selectAll={this.selectAll.bind(this)}
            selectNone={this.selectNone.bind(this)}
            onChange={this.filter.bind(this)}
            genders={['male', 'female']}
            tags={this.state.tags}
            countries={this.state.countries}
          />

        </div>

        { showMap && <div className="selector"> <svg id="mapSvg" width={this.getWidth()} height={this.getHeight()} onClick={this.hideMenu.bind(this)} xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision">
          <g id="svgGroup" transform={this.transformation()}>
            {this.renderEdges(elements)}
            {this.renderYears(elements)}
            {this.renderGenders(elements)}
            {this.renderFlags(elements)}
            {this.renderNames(elements)}
          </g>
        </svg> </div>}

        { showMap &&  <ElementMenu hide={this.hideMenu.bind(this)} element={this.state.menu.artist} elementData={this.state.menu.artistData} active={this.state.menu.active} x={this.state.menu.x} y={this.state.menu.y}/> }


      </div>
    );
  }

}

export default withRouter(Map);



// WEBPACK FOOTER //
// ./src/js/components/Map.jsx